export default __webpack_public_path__ + "static/media/reddit.85e0fcdb.svg";